import { allVisibleRegions, regionCodes } from "common/static/regions";

import useAppVariant from "features/common/hooks/useAppVariant";

export default function useVisibleRegionsByVariant() {
  const appVariant = useAppVariant();

  return valuesByVariant[appVariant];
}

export const valuesByVariant = {
  seneca: allVisibleRegions,
  senecaPrimary: [regionCodes.GB],
  plurall: allVisibleRegions,
  goStudentLearning: allVisibleRegions.filter(key =>
    [
      regionCodes.GB,
      regionCodes.DE,
      regionCodes.AT,
      regionCodes.IT,
      regionCodes.ES,
      regionCodes.FR
    ].includes(key)
  )
};
